<template>
	<v-toolbar-items>
		<v-toolbar-title v-if="(notification === undefined || !notification.show) && isManager">
			<v-btn text @click="openMsg">צור מודעה חדשה</v-btn>
		</v-toolbar-title>
		<div v-else-if="notification && Object.keys(notification).length > 0">
			<marquee hspace="2"  v-if="notification.is_run"  scrolldelay="60" bgcolor="#00ffff" class="marquee" height="100%" direction="right" @click="openMsg"
			>
				<span>
					<span>{{ notification.title }} </span> <span>{{ notification.content }}</span>
					<span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
					<span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>

				</span>
			</marquee>
			<div v-else class="marquee" style="overflow-y: auto;text-align: center"  @click="openMsg" >
				<span>{{ notification.title }} </span> <span>{{ notification.content }}</span>
			</div>
		</div>

		<popup-dialog v-model="msg">
			<notifications-view v-if="msg" @save="msg = false"></notifications-view>
		</popup-dialog>
	</v-toolbar-items>
</template>

<script>
	import PopupDialog from "../scaffoldings/PopupDialog";
	import NotificationsView from "../view/notifications/NotificationsView";
	import * as NotificationsModule from "../store/modules/Notification.module";

	export default {
		name: "notification-box",
		components: {PopupDialog, NotificationsView},
		data() {
			return {
				msg: false,
				key:1
			};
		},
		computed: {
			notification() {
				return this.$store.state.NotificationModule.notifications[0];
			},
			isManager() {
				return this.$store.getters.isManager;
			},

		},
		created() {
			this.$store.dispatch(NotificationsModule.types.FETCH);
		},
		methods: {
			onFinish(){
				console.log(2222);
			},
			openMsg() {
				this.msg = true;
			},
		},
	};
</script>
<style scoped>
.marquee {
  width: 90%;
}

@media screen and (min-width: 750px) {
  .marquee {
    width: 750px;
  }
}
</style>
